import { schema } from 'normalizr';
import { SCHEMA_TYPE_SCHEMA_SPECS } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const schemaSpecSchema = new schema.Entity(SCHEMA_TYPE_SCHEMA_SPECS, {
  owner: userSchema,
  org: orgSchema,
});

export default schemaSpecSchema;
